import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { UsageGuide, UsageGuideScope } from "../../productUsageGuides.types";
import { requestUsageGuideByScope } from "./usageGuideByScope.request";

const useUsageGuideByScope = (
  scope: UsageGuideScope,
  options?: QueryOptions<UsageGuide | null, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["product-usage-guides", "scope", scope],
    queryFn: async () => await requestUsageGuideByScope(scope),
    enabled: Boolean(scope.productId ?? scope.categoryId),
    onError: toastServerError,
    ...options
  });

  return { guide: data ?? null, ...rest };
};

export default useUsageGuideByScope;
